var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00125 7.00125C6.7676 7.00171 6.54116 6.92033 6.36125 6.77125L0.361252 1.77125C0.157036 1.60151 0.0286112 1.3576 0.0042315 1.09318C-0.0201482 0.82875 0.0615137 0.565469 0.231252 0.361252C0.400991 0.157035 0.644902 0.0286112 0.909329 0.00423152C1.17375 -0.0201482 1.43704 0.0615132 1.64125 0.231252L7.00125 4.71125L12.3613 0.391253C12.4635 0.308187 12.5812 0.246155 12.7076 0.208723C12.8339 0.171291 12.9664 0.159198 13.0974 0.173137C13.2285 0.187076 13.3554 0.226773 13.4711 0.289947C13.5867 0.35312 13.6887 0.438526 13.7713 0.541252C13.8628 0.644074 13.9322 0.7647 13.975 0.895574C14.0178 1.02645 14.0331 1.16475 14.0199 1.30181C14.0068 1.43887 13.9655 1.57175 13.8986 1.6921C13.8317 1.81246 13.7407 1.91771 13.6313 2.00125L7.63125 6.83125C7.44617 6.95677 7.22435 7.01662 7.00125 7.00125Z",
    fill: "#EFC155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrange);
export default __webpack_public_path__ + "static/media/arrow-orange.9524d8f35dae29e4089be81f4596e605.svg";
export { ForwardRef as ReactComponent };